<template>
  <div class="container">

    <div class="topBox">
      <h1>套餐管理</h1>
      <el-button type="primary" @click="onClickAddNewData()">添加套餐</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="imageList" label="图片" width="150">
        <template #default="{ row }">
          <div class="imgBox">
            <img v-if="row.tailCarImageList && row.tailCarImageList.length > 0" :src="row.tailCarImageList[0].url"
              alt="图片" />
            <span v-if="row.tailCarImageList">*{{ row.tailCarImageList.length }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="nameZh" label="标题" width="300" />
      <el-table-column prop="price" label="价格" width="100">
        <template #default="{ row }">
          ¥{{ row.price }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="200" />

      <el-table-column fixed="right" label="操作" min-width="120">
        <template #default="{ row }">
          <el-button link type="primary" size="small" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button link type="danger" size="small" @click="handleShowDeleteDialog(row)">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>


    <el-dialog v-model="dialogFormVisible" title="编辑套餐" width="800">
      <el-form :model="currentCarData" ref="ruleFormRef" :rules="rules">

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="维语套餐名称" prop="name">
              <el-input v-model="currentCarData.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="中文套餐名称" prop="nameZh">
              <el-input v-model="currentCarData.nameZh"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="24">
            <el-form-item label="维语套餐详情" prop="description">
              <el-input type="textarea" v-model="currentCarData.description"
                @change="handleDescriptionChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="中文套餐详情" prop="descriptionZh">
              <el-input type="textarea" v-model="currentCarData.descriptionZh"
                @change="handleDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="头车品牌" prop="topCarBrandNameZh">
              <el-select v-model="currentCarData.topCarBrandNameZh" placeholder="请选择头车车型"
                @change="handleDialogSelectionChangeTopCar1">
                <el-option v-for="item in categories" :key="item.id" :label="item.labelZh" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="头车车型" prop="topCarNameZh">
              <el-select v-model="currentCarData.topCarNameZh" placeholder="请选择尾车车型"
                @change="handleDialogSelectionChangeTopCar2">
                <el-option v-for="item in childrenCategorisTopCar" :key="item.id" :label="item.labelZh"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="相关图片" prop="imagesTopCar">
              <div class="avatar-container">
                <div class="avatar-box" v-for="(item, index) in imageArrayTopCar" :key="item.id">
                  <el-image class="avatar" :src="item.url" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage1(index)" />

                </div>

                <el-upload v-if="imageArrayTopCar.length < 7" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload1" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="尾车品牌" prop="tailCarBrandNameZh">
              <el-select v-model="currentCarData.tailCarBrandNameZh" placeholder="请选择头车车型"
                @change="handleDialogSelectionChangeTailCar1">
                <el-option v-for="item in categories" :key="item.id" :label="item.labelZh" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="尾车车型" prop="tailCarNameZh">
              <el-select v-model="currentCarData.tailCarNameZh" placeholder="请选择尾车车型"
                @change="handleDialogSelectionChangeTailCar2">
                <el-option v-for="item in childrenCategorisTailCar" :key="item.id" :label="item.labelZh"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="相关图片" prop="imagesTopCar">
              <div class="avatar-container">
                <div class="avatar-box" v-for="(item, index) in imageArrayTailCar" :key="item.id">
                  <el-image class="avatar" :src="item.url" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage2(index)" />

                </div>

                <el-upload v-if="imageArrayTailCar.length < 7" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload2" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label="尾车数量" prop="tailCarNum">
              <el-input v-model="currentCarData.tailCarNum" type="Number"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="价格(元)" prop="price">
              <el-input v-model="currentCarData.price" type="Number" min="0"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label="可用时长(小时)" prop="durationTime">
              <el-input v-model="currentCarData.durationTime" type="Number"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="可用公里(公里)" prop="km">
              <el-input v-model="currentCarData.km" type="Number"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label="头车超时费用(1公里/填写价格)" prop="topOverTimePrice">
              <el-input v-model="currentCarData.topOverTimePrice" type="Number" min="0"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="头车超公里费用(1小时/填写价格)" prop="topOverKmPrice">
              <el-input v-model="currentCarData.topOverKmPrice" type="Number" min="0"></el-input>
            </el-form-item>
          </el-col>


        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label="尾车超时费用(1小时/填写价格)" prop="tailOverTimePrice">
              <el-input v-model="currentCarData.tailOverTimePrice" type="number" min="0"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="尾车超公里费用(1公里/填写价格)" prop="tailOverKmPrice">
              <el-input v-model="currentCarData.tailOverKmPrice" type="number" min="0"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="包含" prop="incould">
              <el-checkbox-group v-model="checkList1">
                <el-checkbox v-for="item in checkboxOptions1" :key="item.id" :label="item.id" :value="item.id">
                  {{ item.labelZh }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

        </el-row>


      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="success" @click="dialogMuBan = true">查看实例模板</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData(ruleFormRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogVisible" title="提示" width="300" :before-close="handleClose">
      <span>删除后无法恢复，确定要删除么？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelete()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>


    <el-dialog v-model="dialogMuBan" title="车队套餐模板" width="600">

      <el-row :gutter="20">
        <el-col :span="12">
          <h4>参考模板</h4>

          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">

            <el-carousel height="250px">
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://img0.baidu.com/it/u=1913564695,2398102170&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1120"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://pic.rmb.bdstatic.com/bjh/3ea23100117/240807/da30652ff9381a8eb5ee59d22bd12b7a.png"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://bkimg.cdn.bcebos.com/pic/77c6a7efce1b9d16fdfa51298495a38f8c5494eece6d" fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block;">劳斯莱斯车队</span>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block; color: red;">￥5000</span>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">产品详情</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">头车</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">[保时捷] 帕拉梅拉</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">尾车</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">[奥迪] A6L * 5辆</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">使用时长与公里数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">4小时*30公里</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">超时/超公里费用</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">
                头车200元/小时 20元/公里<br>
                跟车100元/小时 5元/公里
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">包含内容</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                含司机，油费，清洗费，保养费，违章罚款（因司机违章产生）
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">不包含内容</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                婚车鲜花装饰，超时/超公里费用，过路费
              </span>
            </div>

            <span
              style="font-size: 12px; margin-left: 10px; color: black; display: block; text-align: start;width:100%;">更多细节和详细介绍...</span>


          </div>

        </el-col>
        <el-col :span="12">
          <h4>您编辑的</h4>
          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">
            <el-carousel height="250px">
              <el-carousel-item v-for="(image, index) in currentCarData.topCarImageList" :key="index">
                <el-image style="width: 100%; height: 250px" :src="image.url" fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block;">{{ currentCarData.nameZh }}</span>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block; color: red;">￥{{ currentCarData.price }}</span>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">产品详情</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">头车</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">[{{
                currentCarData.topCarBrandNameZh }}]
                {{ currentCarData.topCarNameZh }}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">尾车</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">[{{
                currentCarData.tailCarBrandNameZh }}]
                {{ currentCarData.tailCarNameZh }} * {{ currentCarData.tailCarNum }}辆</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">使用时长与公里数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">{{
                currentCarData.durationTime }}小时*{{ currentCarData.km }}公里</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">超时/超公里费用</span>
              <span style="font-size: 12px; margin-left: 10px; color: black; text-align: start;">
                头车{{ currentCarData.topOverTimePrice }}元/小时 {{ currentCarData.topOverKmPrice }}元/公里<br>
                跟车{{ currentCarData.tailOverTimePrice }}元/小时 {{ currentCarData.tailOverKmPrice }}元/公里
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">包含内容</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                {{ getContainIdData(currentCarData.containId) }}
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">不包含内容</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                {{ getexcludeIdData(currentCarData.excludeId) }}
              </span>
            </div>

            <span
              style="font-size: 12px; margin-left: 10px; color: black; display: block; text-align: start;width:100%;">
              {{ currentCarData.descriptionZh }}
            </span>


          </div>

        </el-col>
      </el-row>

    </el-dialog>

  </div>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { get, upload, post } from '@/api/http';
import { useStore } from 'vuex';


export default {
  name: 'PhotosPage',
  setup() {
    const store = useStore();

    const tableData = ref([]);
    const categoriesCarType = ref([]);
    const categoriesCarTag = ref([]);
    const currentCarData = ref(null);
    const dialogFormVisible = ref(false);
    const imageArrayTopCar = ref([]);
    const imageArrayTailCar = ref([]);
    const checkList1 = ref([]);

    const ruleFormRef = ref(null);

    const categories = ref([]);
    const childrenCategorisTopCar = ref([]);
    const childrenCategorisTailCar = ref([]);
    const diaologTopCarBrandType = ref({});
    const diaologTopCarType = ref({});
    const diaologTailCarBrandType = ref({});
    const diaologTailCarType = ref({});

    const checkboxOptions1 = ref([]);

    const dialogVisible = ref(false);

    const dialogMuBan = ref(false);



    const shopId = computed(() => {
      const shop = store.state.shop;
      return shop ? shop.id : '';
    });


    // 表单验证规则
    const rules = reactive({
      imagesTopCar: [
        {
          required: true,
          validator: (rule, value, callback) => {

            if (imageArrayTopCar.value.length <= 0) {
              callback(new Error('头车图片不能为空'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],
      name: [{ required: true, message: '维语名称不能为空', trigger: 'blur' }],
      nameZh: [{ required: true, message: '中文名称不能为空', trigger: 'blur' }],
      description: [{ required: true, message: '维语详情不能为空', trigger: 'blur' }],
      descriptionZh: [{ required: true, message: '中文详情不能为空', trigger: 'blur' }],
      price: [{ required: true, message: '价格不能为空', trigger: 'blur' }],
      shopId: [{ required: true, message: '店铺ID不能为空', trigger: 'blur' }],
      topCarBrandNameZh: [{ required: true, message: '请选择头车品牌', trigger: 'change' }],
      topCarNameZh: [{ required: true, message: '请选择头车车型', trigger: 'change' }],
      tailCarBrandNameZh: [{ required: true, message: '请选择尾车品牌', trigger: 'change' }],
      tailCarNameZh: [{ required: true, message: '请选择尾车车型', trigger: 'change' }],
      tailCarNum: [{ required: true, message: '请选择尾车数量', trigger: 'blur' }],
      durationTime: [{ required: true, message: '可用时长不能为空', trigger: 'blur' }],
      km: [{ required: true, message: '可用公里不能为空', trigger: 'blur' }],
      topOverTimePrice: [{ required: true, message: '超时费用不能为空', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      topOverKmPrice: [{ required: true, message: '超公里费用不能为空', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      tailOverTimePrice: [{ required: true, message: '请输入', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      tailOverKmPrice: [{ required: true, message: '请输入', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],

      incould: [
        {
          required: true,
          validator: (rule, value, callback) => {

            if (checkList1.value.length <= 0) {
              callback(new Error('请至少选择一个包含项'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],

    });


    onMounted(() => {
      getCategoryData();
      getData();
    });

    const getCategoryData = async () => {
      try {
        const response = await get('adminCategories/getCategoriesByParentId/11')
        if (response.code === 200) {
          categories.value = response.data[0].children;
          checkboxOptions1.value = response.data[1].children;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }




    const getData = async () => {
      try {
        const response = await get('adminCar/allShopCars', { "shopId": shopId.value })
        if (response.code === 200) {
          tableData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const addData = async () => {


      var containId = checkList1.value.join(',');

      var checkList2 = checkboxOptions1.value.filter(item =>
        !containId.includes(item.id)
      );
      var excludeId = checkList2.map(item => item.id).join(',');


      const dataParam = {
        'name': currentCarData.value.name,
        'nameZh': currentCarData.value.nameZh,
        'description': currentCarData.value.description,
        'descriptionZh': currentCarData.value.descriptionZh,
        'topCarBrandType': diaologTopCarBrandType.value.id,
        'topCarBrandName': diaologTopCarBrandType.value.label,
        'topCarBrandNameZh': diaologTopCarBrandType.value.labelZh,
        'tailCarBrandType': diaologTailCarBrandType.value.id,
        'tailCarBrandName': diaologTailCarBrandType.value.label,
        'tailCarBrandNameZh': diaologTailCarBrandType.value.labelZh,
        'topCarType': diaologTopCarType.value.id,
        'topCarName': diaologTopCarType.value.label,
        'topCarNameZh': diaologTopCarType.value.labelZh,
        'tailCarType': diaologTailCarType.value.id,
        'tailCarName': diaologTailCarType.value.label,
        'tailCarNameZh': diaologTailCarType.value.labelZh,
        'tailCarNum': currentCarData.value.tailCarNum,
        'topImagesId': currentCarData.value.topImagesId,
        'tailImagesId': currentCarData.value.tailImagesId,
        'price': currentCarData.value.price,
        'durationTime': currentCarData.value.durationTime,
        'km': currentCarData.value.km,
        'topOverTimePrice': currentCarData.value.topOverTimePrice,
        'tailOverTimePrice': currentCarData.value.tailOverTimePrice,
        'topOverKmPrice': currentCarData.value.topOverKmPrice,
        'tailOverKmPrice': currentCarData.value.tailOverKmPrice,
        'containId': containId,
        'excludeId': excludeId,
        'shopId': shopId.value,
        'status': currentCarData.value.status,
      };


      if (currentCarData.value.id) {
        dataParam.id = currentCarData.value.id;
      }


      try {
        const response = await post('adminCar/addCars', dataParam)
        if (response.code === 200) {
          dialogFormVisible.value = false;
          ElMessage.success("保存成功");
          getData();
        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }


    }



    const uploadFile = async (file, type) => {
      await upload('adminUpload/image', file, { 'type': 21 })
        .then(response => {

          if (response.code == 200) {

            if (type == 1) {
              imageArrayTopCar.value.push(response.data);
              currentCarData.value.topImagesId = imageArrayTopCar.value.map(item => item.id).join(',');
            } else {
              imageArrayTailCar.value.push(response.data);
              currentCarData.value.tailImagesId = imageArrayTailCar.value.map(item => item.id).join(',');
            }

          } else {
            ElMessage.error('上传失败，请重试')
          }

        })
        .catch(error => {
          console.error('请求失败', error)
          ElMessage.error('请求失败，请重试')
        });
    }

    const deleteData = async (id) => {
      await get('adminResourse/deleteResourse/' + id)
        .then(() => {
          ElMessage.success("删除成功");
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const beforeUpload1 = (file) => {


      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file, 1);
      return false; // 阻止默认上传行为
    }


    const beforeUpload2 = (file) => {


      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file, 2);
      return false; // 阻止默认上传行为
    }


    const deleteCarData = async (id) => {
      await get('adminCar/deleteCars/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;

        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const handleEdit = (row) => {
      // 打印或处理编辑数据

      currentCarData.value = row;

      imageArrayTopCar.value = row.topCarImageList;
      imageArrayTailCar.value = row.tailCarImageList;

      const obj1 = categories.value.find(item => item.id === row.topCarBrandType);
      diaologTopCarBrandType.value = obj1;
      const obj2 = categories.value.find(item => item.id === row.tailCarBrandType);
      diaologTailCarBrandType.value = obj2;

      const obj3 = obj1.children.find(item => item.id === row.topCarType);
      diaologTopCarType.value = obj3;
      const obj4 = obj2.children.find(item => item.id === row.tailCarType);
      diaologTailCarType.value = obj4;

      childrenCategorisTopCar.value = obj1.children;
      childrenCategorisTailCar.value = obj2.children;

      checkList1.value = [];

      if (row.containId != null) {
        checkList1.value = row.containId.split(',').map(Number);
      }

      dialogFormVisible.value = true;
    };

    const onClickAddNewData = () => {

      currentCarData.value = {};
      imageArrayTopCar.value = [];
      imageArrayTailCar.value = [];
      childrenCategorisTopCar.value = [],
        childrenCategorisTailCar.value = [],
        diaologTopCarBrandType.value = {},
        diaologTopCarType.value = {},
        diaologTailCarBrandType.value = {},
        diaologTailCarType.value = {},
        dialogFormVisible.value = true;

    }

    const onClickAddData = async (formEl) => {
      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const removeImage1 = (index) => {
      if (imageArrayTopCar.value[index] && imageArrayTopCar.value[index].id) {
        deleteData(imageArrayTopCar.value[index].id);
        imageArrayTopCar.value.splice(index, 1);
        currentCarData.value.imagesId = imageArrayTopCar.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }

    const removeImage2 = (index) => {
      if (imageArrayTailCar.value[index] && imageArrayTailCar.value[index].id) {
        deleteData(imageArrayTailCar.value[index].id);
        imageArrayTailCar.value.splice(index, 1);
        currentCarData.value.imagesId = imageArrayTailCar.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }


    const handleDialogSelectionChangeTopCar1 = async (value) => {
      const obj = categories.value.find(item => item.id === value);
      diaologTopCarBrandType.value = obj;
      childrenCategorisTopCar.value = diaologTopCarBrandType.value.children;
      currentCarData.value.topCarName = null;

    }
    const handleDialogSelectionChangeTopCar2 = async (value) => {
      const obj = childrenCategorisTopCar.value.find(item => item.id === value);
      diaologTopCarType.value = obj;

    }
    const handleDialogSelectionChangeTailCar1 = async (value) => {
      const obj = categories.value.find(item => item.id === value);
      diaologTailCarBrandType.value = obj;
      childrenCategorisTailCar.value = diaologTailCarBrandType.value.children;
      currentCarData.value.tailCarName = null;

    }
    const handleDialogSelectionChangeTailCar2 = async (value) => {
      const obj = childrenCategorisTailCar.value.find(item => item.id === value);
      diaologTailCarType.value = obj;

    }

    const handleShowDeleteDialog = (row) => {
      currentCarData.value = row;
      dialogVisible.value = true;
    }

    const handleDelete = () => {
      deleteCarData(currentCarData.value.id);
    }

    const getContainIdData = (value) => {
      const list = value.split(',').map(Number);

      const names = list.map(id => {
        const item = checkboxOptions1.value.find(item => item.id === id);
        return item ? item.labelZh : '';
      }).filter(label => label);

      return names.join(', ');
    }

    const getexcludeIdData = (value) => {
      const list = value.split(',').map(Number);

      const names = list.map(id => {
        const item = checkboxOptions1.value.find(item => item.id === id);
        return item ? item.labelZh : '';
      }).filter(label => label);

      return names.join(', ');
    }


    const handleDescriptionChange = (val) => {
      currentCarData.value.description = val.replace(/\r?\n/g, '\n')
    }

    const handleDescriptionZhChange = (val) => {
      currentCarData.value.descriptionZh = val.replace(/\r?\n/g, '\n')
    }


    return {
      tableData,
      categoriesCarType,
      categoriesCarTag,
      categories,
      childrenCategorisTopCar,
      childrenCategorisTailCar,
      diaologTopCarBrandType,
      diaologTopCarType,
      diaologTailCarBrandType,
      diaologTailCarType,
      currentCarData,
      handleEdit,
      dialogFormVisible,
      checkList1,
      onClickAddData,
      onClickAddNewData,
      rules,
      ruleFormRef,
      removeImage1,
      removeImage2,
      beforeUpload1,
      beforeUpload2,
      uploadFile,
      handleDialogSelectionChangeTailCar1,
      handleDialogSelectionChangeTailCar2,
      handleDialogSelectionChangeTopCar1,
      handleDialogSelectionChangeTopCar2,
      imageArrayTopCar,
      imageArrayTailCar,
      checkboxOptions1,
      dialogVisible,
      handleShowDeleteDialog,
      handleDelete,
      dialogMuBan,
      getContainIdData,
      getexcludeIdData,
      handleDescriptionChange,
      handleDescriptionZhChange

    }



  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.topBox {
  display: flex;
  justify-content: space-between;

}

.imgBox {
  display: flex;
  align-items: center;
}

.imgBox img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
}

.avatar-container {
  display: flex;
  flex-wrap: wrap;
}

.avatar-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;

}

.avatar-box:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10%;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: white;
}

.delete-icon:hover {
  color: #409EFF;
}

.uploader-icon {
  font-size: 25px;
  color: #8c939d;
  text-align: center;
  margin-top: 50%;
  transform: translate(0%, -50%);
}
</style>
